"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _App = _interopRequireDefault(require("./App"));

var app = function app(_ref) {
  var onLastSave = _ref.onLastSave,
      appHeight = _ref.appHeight;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "careerplug-form-builder-app"
    },
    /*#__PURE__*/
    _react["default"].createElement(_App["default"], {
      onLastSave: onLastSave,
      appHeight: appHeight
    }))
  );
};

var _default = exports["default"] = app;